module.exports = __webpack_public_path__ + "img/flags/MP.9961559.png";